export default {
  'form.fields.first_name': 'VORNAME(N)',
  'form.fields.last_name': 'NACHNAME',
  'form.fields.email': 'E-MAIL',
  'form.fields.gender': 'GENDER',
  'form.fields.nationality': 'NATIONALITÄT',
  'form.fields.organisation': 'ORGANISATION',
  'form.fields.position': 'POSITION',

  'ui.signup': 'Anmelden',
  'ui.gdpr': 'Datenschutzgrundverordnung',
  'ui.agb': 'Geschäfts- und Stornobedingungen',

  'ui.thankyou': 'Vielen Dank für Ihre Anmeldung!',
  'ui.thankyou.message': 'Eine Bestätigung geht Ihnen in Kürze per E-Mail zu.',

  'signupform.checkbox.gdpr': 'Ich bin mit der Speicherung meiner persönlichen Daten für den Zweck der Abwicklung der Veranstaltung nach Richtlinien der Europäischen {link} einverstanden.',
  'signupform.checkbox.newsletter': 'Ich möchte die ACP News und relevante Informationen über ACP Veranstaltungen erhalten und bin mit einer diesbezüglichen Speicherung meiner persönlichen Daten nach Richtlinien der Europäischen Datenschutzgrundverordnung einverstanden. Meine Einwilligung kann ich jederzeit widerrufen.',
  'signupform.checkbox.agb': 'Ich akzeptiere die {link}.'
}
